import { ErrorBase } from '@/errors/ErrorBase';

export class UserNotFoundInNameListError extends ErrorBase {
    static get defaultMessage(): string {
        return 'ご利用のアカウントは登録されていないため、ログインすることができません。';
    }

    static get errorName(): string {
        return 'UserNotFoundInNameListError';
    }
}
